module.exports = __webpack_public_path__ + "static/media/5 1 Leseforstaelse Intro.d03fb746.mp3";